export default "__VITE_ASSET__8e2396ae__"